module.exports = __webpack_public_path__ + "static/img/rxlog.1e58300d.png";